function zenCCadjustCartItems()
{
  zenCCadjustCartItemStyles();
  // zenCCreplaceCartImages();
}

function zenCCadjustCartItemStyles()
{
  // console.log("zenCCadjustCartItemStyles()");
  const items = document.querySelectorAll('.cart-item');
  items.forEach(it => {
    // console.log("found cart item: " + it);
    const properties = it.querySelectorAll('.product-option dd');
    let hasCC = false;
    let colors = [];
    properties.forEach(dd => {
      colHex = zenCCpropStrToColorHex(dd.innerHTML);
      if (colHex)
      {
        // console.log("found CC property: " + dd.innerHTML);
        dd.style.borderRadius = "12px";
        dd.style.padding = "3px 12px 3px 12px";
        dd.style.display = "block";

        let [colTypo, visBorder] = zenCCgetSwatchStyles(colHex);
        
        dd.style.backgroundColor = colHex;
        dd.style.color = colTypo;
        dd.style.border = visBorder ? "1px solid #000" : 0;

        colors.push(colHex);
        hasCC = true;
      }
    });

    if (hasCC) {
      // add cc parameters to link url
      let links = it.querySelectorAll('a.cart-item__link, a.cart-item__name');
      links.forEach(l => {
        var url = new URL(l.href);
        var searchParams = url.searchParams;
        searchParams.set('col1', colors[0].substring(1));
        searchParams.set('col2', colors[1].substring(1));
        searchParams.set('colSeam', colors[2][6] == 0 ? '0' : '1');
        url.search = searchParams.toString();
        l.href = url;
      });
    }
  });
}

function zenCCgetSwatchStyles(colSwatchHEX)
{
    // console.log("zenCCgetSwatchStyles()");
    colorText = getColorContrast(colSwatchHEX);
    visBorder = colorText == "#000000" ? true : false;
    return [colorText, visBorder];
}

function zenCCpropStrToColorHex(strPropVal)
{
  // console.log("zenCCpropStrToColorHex(" + strPropVal + ")");
  strPropVal = strPropVal.split(" ")[0].toLowerCase().trim();
  if (strPropVal === 'white'){ 
    return "#FFFFFF"; 
  } else if (strPropVal === 'black'){
    return "#000000";
  } else if (strPropVal.charAt(0) === '#') { 
    return strPropVal; 
  } else {
    // color not recognized
    return false;
  }
}



// function zenCCreplaceCartImages()
// {
//   console.log("zenCCreplaceCartImages()");
//   const cartItemImages = document.querySelectorAll('.cart-item__image');
//   cartItemImages.forEach(img => {
//     zenCCreplaceCartImage(img);
//   });
// }

// function zenCCreplaceCartImage(img)
// {
//     console.log("zenCCreplaceCartImage(img) src=" + img.src );

//     let canvas = img.parentElement.querySelector(".zenCCcanvCart");
//     console.log("innerHTML BEFORE " + img.parentElement.innerHTML)
//     if (!canvas.hasAttribute("data-cc-drawn")){
//       console.log(" drawing canvas..." );
//       // const attr = document.createAttribute("data-cc-drawn");
//       // attr.value = "true";
//       // canvas.setAttributeNode(attr); 
//       canvas.setAttribute("data-cc-drawn", "true");

//       let texBase = img.parentElement.querySelector(".zenCCtexBase");
//       let texZones = img.parentElement.querySelector(".zenCCtexZones");
//       let col1Hex = img.getAttribute("data-cc-color1");
//       let col2Hex = img.getAttribute("data-cc-color2");
//       let colSeamWord = img.getAttribute("data-cc-colorSeam");
//       let col1 = hexToRgb(col1Hex);
//       let col2 = hexToRgb(col2Hex);
//       let colSeam = colSeamWord === "White" ? [255, 255, 255] : [0, 0, 0];
//       let colTypo = col2;
    
//       canvas.width = img.width;
//       canvas.height = img.height;
//       let dpi = new ZenCCDPI(canvas);
//       dpi.setTextures(texBase, texZones);
//       dpi.updateColors(col1, col2, colTypo, colSeam, false);
      
//       const dataURL = canvas.toDataURL("image/png");
//       // console.log(dataURL);
//       // img.src = dataURL;
      
//       console.log("innerHTML AFTER " + img.parentElement.innerHTML)
//     }
//     // texBase.remove();
//     // texZones.remove();
//     // canvas.remove();
// }


// function drawDpiTEST()
// {
//   var canvas = document.createElement('canvas');
//       canvas.width = width;
//       canvas.height = height;
//       const context = canvas.getContext('2d');
//       context.fillStyle = 'red';
//       context.fillRect(0,0,width,height);
//   return canvas;
// }
